import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }) => {
    const location = useLocation();
    useEffect(() => {
        if (!location.hash) {
            window.scrollTo(0, 0);
            return undefined;
        }
        // links like /#pricing: wait for the page to render, then scroll to the
        // section, leaving room for the sticky header
        const timer = setTimeout(() => {
            const target = document.getElementById(location.hash.slice(1));
            if (target) {
                const top = target.getBoundingClientRect().top + window.scrollY - 90;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        }, 100);
        return () => clearTimeout(timer);
    }, [location]);

    return <>{children}</>;
};

export default ScrollToTop;
